import React, { useEffect } from "react";
import { QUESTION_ACTIONS, useFollowUp } from "providers/FollowUpProvider";
import { Flex, Center, Text, Button, Spinner, HStack, VStack } from "@chakra-ui/react";
import checkIcon from "assets/images/check.svg";
import { useHistory } from "react-router";
import { useAsyncFn } from "react-use";
import { TaskService } from "services/taskService";
import { CloseIcon } from "@chakra-ui/icons";
import { useUser } from "providers/UserProvider";
import { usePreschool } from "providers/PreschoolProvider";
import { useTranslation } from "react-i18next";
import HelpdeskComponent from "common/Helpdesk";

export default function FollowUpFinish() {
  const { dispatch, tasks, setChild, child, originalTasks, followupInfo, ownComment, groupComment, setOwnComment } =
    useFollowUp();
  const { replace } = useHistory();
  const { user } = useUser();
  const { preschool, departmentId } = usePreschool();
  const { t } = useTranslation();

  const [{ loading, error, value }, submit] = useAsyncFn(() => {
    const filterTask = tasks.filter(task => task.type !== "language_analysis");
    if (tasks.length && child.gender) {
      let payload: any = {
        followUpId: followupInfo.id,
        jsonValue: JSON.stringify(TaskService.answerSummary(filterTask)),
        teacherEmailAddress: user.email,
        childGender: child.gender,
        //   childBirthDate: child.birthdate ? new Date(child.birthdate).toISOString() : null,
        preschoolId: preschool.id,
        departmentId,
        organizationId: user.organizationId,
        individualComment: ownComment,
        groupComment: groupComment,
        childCode: child.code,
        audioRecordings: TaskService.audioSubmit(tasks),
      };

      if (child.age) {
        payload = { ...payload, childAge: child.age };
      }
      if (child.birthdate) {
        payload = { ...payload, childBirthDate: new Date(child.birthdate).toISOString() };
      }

      return TaskService.submitFollowUp(payload);
    }

    return Promise.reject(new Error("No tasks provided"));
  }, []);

  useEffect(() => {
    submit();
  }, []);

  useEffect(() => {
    if (error) console.log("Result submit error:", error);
  }, [error]);

  useEffect(() => {
    dispatch({
      type: QUESTION_ACTIONS.SET_QUESTIONS,
      payload: originalTasks,
    });

    setOwnComment("");
  }, []);

  const startNewFollowUp = () => {
    setChild({ gender: "", birthdate: "", code: "" });
    dispatch({
      type: QUESTION_ACTIONS.UPDATE_CURRENT_TASK,
    });

    replace("/welcome");
  };

  const tryAgain = () => {
    submit();
  };
  const startNewButtonProps = error
    ? {
        variant: "outline" as const,
        height: "40px",
        bg: "",
        color: "#FF5099",
        borderColor: "#FF5099",
        opacity: 1,
        _hover: {
          bg: "",
          color: "#FF5099",
          opacity: 1,
        },
      }
    : {};

  return (
    <Center h="full" w="full">
      <VStack w="100%" h="100%">
        <VStack w="100%" h="30%" justifyContent="center">
          <HStack w="100%" justifyContent="flex-end" pr="9">
            <HelpdeskComponent />
          </HStack>
        </VStack>
        <VStack align="center" w="100%" justifyContent="center">
          <Flex direction="column" align="center" fontFamily="Catamaran">
            {loading && (
              <>
                <Spinner size="xl" />
                <Text mb="14" mt="7" fontSize="large" fontWeight="light">
                  {t("Complete_FollowUp")}
                </Text>
              </>
            )}

            {error && (
              <>
                <Center boxSize="60px" bgColor="red.600" borderRadius="full">
                  <CloseIcon fontSize="2xl" />
                </Center>
                <Text mb="7" mt="7" fontSize="large" fontWeight="light">
                  {typeof error === "string" ? error : error?.message || t("Check_The_Logs_Error_Text")}
                </Text>
              </>
            )}

            {value && (
              <>
                <Center boxSize="60px" bgColor="#17B1AE" borderRadius="full">
                  <img src={checkIcon} alt="check" style={{ height: "50px" }} />
                </Center>
                <Text mb="14" mt="7" fontSize="large" fontWeight="light">
                  {t("FollowUp_Completed_Success")}
                </Text>
              </>
            )}
            {error && (
              <>
                <Text mt="2" fontSize="large" fontWeight="light" textAlign={"center"}>
                  {t("Try_Again_Msg_Part1")}
                </Text>
                <Text mb="12" mt="2" fontSize="large" fontWeight="light" textAlign={"center"}>
                  {t("Try_Again_Msg_Part2")}
                </Text>
                <Button marginBottom={5} onClick={tryAgain}>
                  {t("Try_Again")}
                </Button>
              </>
            )}
            <Button {...startNewButtonProps} onClick={startNewFollowUp}>
              {t("Start_New_FollowUp_Text")}
            </Button>
          </Flex>
        </VStack>
      </VStack>
    </Center>
  );
}
